import { Functions } from "../../Services/functions";

export class Packing {

  constructor(
    public order?: number,
    public depth?: number,
    public length?: number,
    public weight?: number,
    public width?: number,
    public internationalPid?: string,
    public contentQuantity?: number,
    public unit?: string,
    public unitDescription?: string,
    public quantityMin?: number,
    public quantityMax?: number,
    public guid: string = Functions.newGuid()
  ) {

  }
}
